export default {"src":"/_next/static/media/code4rena-icon.b350a3d4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};